import React from 'react'
import cx from 'classnames'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import { Skeleton } from '@mui/material'
import { isFunction } from 'libraries/lodash'
import Icon from 'components/shared/Icon'

const KeyPicks = ({
  keyPicks,
  getUrl,
  handleOnClick,
  iconName,
  pending,
  className = '',
  cxNames = '',
  getItemDataAttributes = null,
  newTab = true
}) => {
  return (
    <section className={className}>
      <Grid container spacing={0}>
        {(pending ? [...Array(3)] : keyPicks).map((item, index) => {
          const props = pending
            ? {}
            : {
                href: getUrl(item),
                onClick: handleOnClick,
                ...(isFunction(getItemDataAttributes) ? getItemDataAttributes(item) : {})
              }

          return (
            <Grid key={index} item xs={12} sm={4}>
              <a
                {...props}
                target={newTab ? '_blank' : undefined}
                rel={newTab ? 'noopener noreferrer' : undefined}
                className={cx(
                  cxNames.tile.borderColor,
                  'relative h6 h4-m bg-white bb-thick db flex items-center justify-between',
                  'black f5 no-underline hover-cadet-blue hover-underline ph6 ph7-m'
                )}
              >
                <Grid container justifyContent='space-between' alignItems='center'>
                  <Grid item xs={11} zeroMinWidth>
                    {
                      pending
                        ? <Skeleton width='65%' />
                        : (
                          <h3 className='lh-solid f5 fw6 truncate'>
                            {item.title}
                          </h3>
                          )
                    }
                  </Grid>
                  {!!iconName && (
                    <Grid item xs={1} sx={{ display: { xs: 'block', sm: 'none', md: 'block' } }}>
                      <Icon name={iconName} className='w7 vm black' />
                    </Grid>
                  )}
                </Grid>
                {index !== 0 && (
                  <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={cx('absolute left0 top-50 y--50 h-50 bl b--black', cxNames.tile.borderColor)} />
                  </Box>
                )}
              </a>
            </Grid>
          )
        })}
      </Grid>
    </section>
  )
}

export default KeyPicks
